import { t, use, default as df } from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import jp from './locales/jp.json';
import { LOCALE } from '@/constants/config';

const resources = {
  en: {
    translation: en,
  },
  jp: {
    translation: jp,
  },
};

use(initReactI18next).init({
  resources,
  lng: LOCALE,
  interpolation: {
    escapeValue: false,
  },
});

export const trans = t;

export default df;
